import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  httpError: null,
};

const messagesSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    setHttpError: (state, { payload }) => {
      state.httpError = payload;
    },
  },
});
const { actions, reducer } = messagesSlice;

export const { setHttpError } = actions;
export default reducer;

// selectors
export const httpErrorSelector = (state) => state.messages.httpError;
